import React from 'react';
import SubPageTemplate from '../components/SubPageTemplate';

const SolutionA = () => {
  const features = [
    { title: 'AI-Powered Support', description: 'Instant, intelligent customer assistance' },
    { title: 'Omnichannel Experience', description: 'Consistent service everywhere' },
    { title: 'Smart Routing', description: 'Get customers to the right help fast' },
    { title: 'Self-Service Portal', description: 'Empower customers to help themselves' },
    { title: 'Analytics Dashboard', description: 'Track satisfaction and performance' },
    { title: 'Multilingual Support', description: 'Serve global customers' },
  ];

  return (
    <SubPageTemplate
      title="Customer Service"
      description="AI-powered support that delights customers and empowers your team."
      features={features}
    />
  );
};

export default SolutionA;
